function toLeadModel ({
  firstname,
  middlename,
  lastname,
  fullname,
  email,
  phone1,
  media_type,
  age,
  dob,
  gender,
  test,
  ip,
  service_leadid,
  source_service_leadid,
  source_service_trusted_form,
  service_trusted_form,
  signup_url,
  consent_url,
  warning,
  ...otherFields
}) {
  return {
    lead: {
      firstname,
      middlename,
      lastname,
      fullname: firstname && lastname ? firstname + ' ' + lastname : null,
      email,
      phone1,
      media_type,
      age,
      dob,
      gender,
      test,
      ip,
      service_leadid,
      source_service_leadid,
      source_service_trusted_form,
      service_trusted_form,
      signup_url,
      consent_url
    },
    otherFields
  }
}

function toLeadAddressModel ({
  address,
  address2,
  city,
  state,
  zip,
  warning,
  ...otherFields
}) {
  return {
    address: {
      address,
      address2,
      city,
      state: state && typeof state === 'string' ? state.toUpperCase() : null,
      zip,
      warning
    },
    otherFields
  }
}

function toLeadEducationModelJustFieldNames ({
  grad_year,
  start_date,
  education_level_id,
  school_type_ids,
  program_name_ids,
  area_study_ids,
  level_interest,
  subject_ids,
  ...otherFields
}, formatSchoolType) {
  return {
    education: {
      grad_year: formatSchoolType
        ? grad_year ? parseInt(grad_year) : null : grad_year,
      start_date,
      education_level_id,
      school_type_ids: formatSchoolType
        ? school_type_ids ? school_type_ids === '3' ? ['1', '2'] : [school_type_ids] : [] : school_type_ids,
      program_name_ids,
      area_study_ids,
      level_interest,
      subject_ids
    },
    otherFields
  }
}

function toLeadEducationModel ({
  grad_year,
  start_date,
  education_level_id,
  school_type_ids,
  program_name_ids,
  area_study_ids,
  level_interest,
  subject_ids,
  ...otherFields
}, formatSchoolType) {
  return {
    education: {
      'lead_education[grad_year]': formatSchoolType
        ? grad_year ? parseInt(grad_year) : null : grad_year,
      'lead_education[start_date]': typeof start_date === 'number' ? start_date : parseInt(start_date),
      'lead_education[education_level_id]': education_level_id,
      'lead_education[school_type_ids]': formatSchoolType
        ? school_type_ids ? school_type_ids === '3' ? ['1', '2'] : [school_type_ids] : [] : school_type_ids,
      'lead_education[program_name_ids]': program_name_ids,
      'lead_education[area_study_ids]': area_study_ids,
      'lead_education[level_interest]': level_interest,
      'lead_education[subject_ids]': subject_ids
    },
    otherFields
  }
}

function toLeadBackgroundModelJustFieldNames ({
  military_type,
  us_citizen,
  internet_pc,
  rn_license,
  teaching_license,
  enrolled_status,
  ...otherFields
}) {
  return {
    background: {
      military_type,
      us_citizen,
      internet_pc,
      rn_license,
      teaching_license,
      enrolled_status
    },
    otherFields
  }
}

function toLeadBackgroundModel ({
  military_type,
  us_citizen,
  internet_pc,
  rn_license,
  teaching_license,
  enrolled_status,
  ...otherFields
}) {
  return {
    background: {
      'lead_background[military_type]': typeof military_type === 'number' ? military_type : parseInt(military_type),
      'lead_background[us_citizen]': typeof us_citizen === 'number' ? us_citizen : parseInt(us_citizen),
      'lead_background[internet_pc]': typeof internet_pc === 'number' ? internet_pc : parseInt(internet_pc),
      'lead_background[rn_license]': typeof rn_license === 'number' ? rn_license : parseInt(rn_license),
      'lead_background[teaching_license]': typeof teaching_license === 'number' ? teaching_license : parseInt(teaching_license),
      'lead_background[enrolled_status]': typeof enrolled_status === 'number' ? enrolled_status : parseInt(enrolled_status)
    },
    otherFields
  }
}

function toLeadCallCenterModel ({
  call_center_dba,
  inbound_transfer_dba,
  inbound_transfer_company,
  outbound_company,
  agent_ip,
  ...otherFields
}) {
  return {
    callcenter: {
      call_center_dba,
      inbound_transfer_dba,
      inbound_transfer_company,
      outbound_company,
      agent_ip
    },
    otherFields
  }
}

function cleanUndefinedAndNull (data) {
  var newData = { ...data }
  Object.keys(newData).forEach(key => (newData[key] === undefined || newData[key] === null) && delete newData[key])
  return newData
}

function toAllModels (unifiedData, formatSchoolType = true) {
  var leadData = toLeadModel(unifiedData)
  var leadAddressData = toLeadAddressModel(leadData.otherFields)
  var leadCallCenterData = toLeadCallCenterModel(leadAddressData.otherFields)
  var leadEducationData = toLeadEducationModelJustFieldNames(leadCallCenterData.otherFields, formatSchoolType)
  var leadBackgroundData = toLeadBackgroundModelJustFieldNames(leadEducationData.otherFields)
  var allData = {
    lead: cleanUndefinedAndNull(leadData.lead),
    lead_address: cleanUndefinedAndNull(leadAddressData.address),
    lead_call_center: cleanUndefinedAndNull(leadCallCenterData.callcenter),
    lead_background: cleanUndefinedAndNull(leadBackgroundData.background),
    lead_education: cleanUndefinedAndNull(leadEducationData.education),
    lead_consent: {},
    lead_custom_value: {}
  }
  var remainingData = leadBackgroundData.otherFields
  const fieldRegx = /(?<model>.*)\[(?<fieldName>.*)\]/
  for (const rKey in remainingData) {
    var keyParts = rKey.match(fieldRegx)?.groups
    if (keyParts) {
      switch (rKey) {
        case 'lead_education[grad_year]':
          allData[keyParts.model][keyParts.fieldName] = parseInt(remainingData[rKey])
          break
        case 'lead_education[school_type_ids]':
          var stIds = remainingData[rKey]
          allData[keyParts.model][keyParts.fieldName] = formatSchoolType
            ? stIds ? stIds === '3' ? ['1', '2'] : [stIds] : [] : stIds
          break
        default:
          allData[keyParts.model][keyParts.fieldName] = remainingData[rKey]
          break
      }
    }
  }
  return allData
}

export const TO_LEAD_MODEL = toLeadModel
export const TO_LEAD_ADDRESS_MODEL = toLeadAddressModel
export const TO_LEAD_EDUCATION_MODEL = toLeadEducationModel
export const TO_LEAD_BACKGROUND_MODEL = toLeadBackgroundModel
export const TO_LEAD_CALLCENTER_MODEL = toLeadCallCenterModel
export const TO_ALL_MODELS = toAllModels
